import { FolderKanban, CheckSquare, Calendar, Inbox, Users, Briefcase, Timer, Zap, User } from 'lucide-react';

export const PROJECT_ICONS = [
  { id: 'folder', icon: FolderKanban },
  { id: 'check', icon: CheckSquare },
  { id: 'calendar', icon: Calendar },
  { id: 'inbox', icon: Inbox },
  { id: 'users', icon: Users },
  { id: 'briefcase', icon: Briefcase },
  { id: 'timer', icon: Timer },
  { id: 'zap', icon: Zap },
];

export const PROJECT_COLORS = [
  '#4A9CC7', '#E74C3C', '#F39C12', '#27AE60', '#9B59B6',
  '#1ABC9C', '#E91E63', '#3F51B5', '#FF5722', '#607D8B'
];

export const FOLDER_COLORS = [
  '#6B7280', '#4A9CC7', '#E74C3C', '#F39C12', '#27AE60', 
  '#9B59B6', '#1ABC9C', '#E91E63', '#3F51B5', '#607D8B'
];

export const getProjectIcon = (iconId) => {
  const iconObj = PROJECT_ICONS.find(i => i.id === iconId);
  if (iconObj) {
    const IconComponent = iconObj.icon;
    return <IconComponent className="w-3 h-3" />;
  }
  return <FolderKanban className="w-3 h-3" />;
};

export const getWorkspaceIcon = (type) => {
  switch (type) {
    case 'team': return <Users className="w-4 h-4" />;
    case 'client': return <Briefcase className="w-4 h-4" />;
    default: return <User className="w-4 h-4" />;
  }
};
